import React from 'react';
import { LoadingSpinner } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './styles';

export const Loading = () => (
  <div aria-busy="true" css={styles.container} data-testid="loading">
    <LoadingSpinner />
  </div>
);
